import styled from "styled-components";
import {BaseModalForm} from "./modalStyle";
import ExitButton from "../buttons/ExitButton";
import {useDispatch, useSelector} from "react-redux";
import React, {useState} from "react";
import {loadProject, patchProject} from "../project/one-project/projectAction";
import {FunctionalModal} from "./FunctionalModal";
import SendFormButton from "../buttons/SendFormButton";

const TextareaModal = ({name, setIsOpen}) => {

    const dispatch = useDispatch()
    const {difficulties, success, threatCreated, threatNotCreated, id} = useSelector(state => state.project)


    const returnText = () => {
        if (name === "success") return success
        if (name === "difficulties") return difficulties
        if (name === "threatCreated") return threatCreated
        if (name === "threatNotCreated") return threatNotCreated
    }
    const [text, setText] = useState(returnText() ? returnText() : "")

    const handleChange = (e) => {
        e.persist();
        const {value} = e.target;
        setText(value)
    }

    const handleSubmit = async (e) => {
        e.preventDefault()
        let data = {
            [name]: text
        }
        await dispatch(patchProject(id, data));
        dispatch(loadProject(id))
        setIsOpen(false)
    }


    const getTitle = () => {
        if (name === "success") {
            return "Succès"
        }
        if (name === "difficulties") {
            return "Cailloux"
        }

        if (name === "threatCreated") {
            return "Les parties prenantes"
        }
        if (name === "threatNotCreated") {
            return "Conduite du changement nécessaire"
        }
    }

    const closeModal = () => {
        setIsOpen(false)
    }

    const displayModal = () => {
        return (
            <Modal onSubmit={handleSubmit}>
                <div className={"flex-row w-100"}>
                    <h1> Modifier : {getTitle()} </h1>
                    <ExitButton
                        closeUpdate={closeModal}
                    />
                </div>
                <textarea
                    value={text ? text : ""}
                    onChange={handleChange}
                    placeholder={"Votre commentaire ici"}
                />
                <SendFormButton actionName={"Enregistrer"} state={true}/>
            </Modal>
        )
    }
    return (
        <FunctionalModal component={displayModal()} setOpen={setIsOpen}/>
    )
}

const Modal = styled(BaseModalForm)`

  height: 350px;
  margin: auto;
  align-items: center;
  padding: 1rem;

  h1 {
    flex-grow: 1;
    font-size: 20px;
    text-align: center;
  }

  .exit-btn {
    align-self: flex-start;
  }

  textarea {
    width: 80%;
    height: 90%;
  }

  @media (min-width: 700px) {
    width: 550px;
    height: 300px;
  }

`

export default TextareaModal